{
  "version": 1,
  "asset_id": "7a322544-6086-40c6-abd7-a1643ab5f996",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/7a322544-6086-40c6-abd7-a1643ab5f996/entities-teaser-poster.jpg",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/7a322544-6086-40c6-abd7-a1643ab5f996/entities-teaser-poster.jpg",
  "original_filename": "entities-teaser-poster.jpg",
  "size": 25413,
  "content_type": "image/jpeg",
  "created_at": "2026-10-14T00:46:05Z"
}
